import { useTableStore } from "@store/filters/filters.store";

const useHandleCompanySelection = () => {
  const { pagination, selection, setTableSelection } = useTableStore("company");

  return (newSelection: string[]) => {
    if (!selection || newSelection.length <= selection.length - pagination.pageSize) {
      setTableSelection([]);
    } else {
      setTableSelection(newSelection);
    }
  };
};

export default useHandleCompanySelection;
